import { NavigationItem } from "@/config/navigation";

interface MobileNavigationProps {
  items: NavigationItem[];
  isOpen: boolean;
  onClose: () => void;
  showAdminButton?: boolean;
  onAdminAction?: () => void;
}

export const MobileNavigation = ({ 
  items, 
  isOpen, 
  onClose, 
  showAdminButton = false,
  onAdminAction 
}: MobileNavigationProps) => {
  if (!isOpen) return null;

  return (
    <div className="lg:hidden py-4 border-t border-border bg-white/95 backdrop-blur-sm">
      <nav className="flex flex-col space-y-2">
        {items.map((item) => (
          <a
            key={item.label}
            href={item.href}
            onClick={onClose}
            className="text-base font-medium text-foreground hover:text-primary transition-smooth px-4 py-3 rounded-md hover:bg-accent min-h-[44px] flex items-center"
          >
            {item.label}
          </a>
        ))}
        {showAdminButton && onAdminAction && (
          <button
            onClick={() => {
              onAdminAction();
              onClose();
            }}
            className="mx-4 mt-2 min-h-[44px] px-4 py-2 border border-border rounded-md bg-background hover:bg-accent text-sm font-medium transition-colors"
          >
            Déconnexion Admin
          </button>
        )}
      </nav>
    </div>
  );
};